import { defineStore } from "pinia";
import { ref } from "vue";

export const useThemeStore = defineStore(
  "theme",
  () => {
    const currentTheme = ref<"light" | "dark">("light");

    function setTheme(theme: "light" | "dark") {
      currentTheme.value = theme;
    }

    return { setTheme, currentTheme };
  },
  {
    persist: true,
  }
);
